/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-explicit-any */
// 皮肤9 - 参考落地页 channelId=6409
import React, { useState, useEffect } from 'react'
import styles from './skin9.module.scss'
import classNames from 'classnames'
import { Toast } from 'antd-mobile'
import { parseNum, isPhone, Storage, isIOS } from '@bihu/common-js'
import getHostNameObj from '@/hooks/get-host-name-obj'
import { TOKEN, ENTER_AGREEMENT } from '@/constants/storage'
import NumberInput from '@/components/number-input/number-input'
import activityApi from '@/apis/activity'
import { clearCachedParams, getCachedParamsAsQueryString } from '@/utils/login-params'
import { useSearchParams } from 'react-router-dom'
import loanCalculateUtils from 'loan-calculate-utils'

interface Props {
  onCallBackParams: (data: any) => void,
  callBack: () => void,
  type?: 'getQuota',
  channelDetail: any,
  phoneValue: string
}

const PERIOD_OPTIONS = [
  {
    text: '3期',
    value: 3
  },
  {
    text: '6期',
    value: 6
  },
  {
    text: '12期',
    value: 12
  },
  {
    text: '24期',
    value: 24
  },
  {
    text: '36期',
    value: 36
  }
]

const YEAR_RATE = 7.2
const MIN_AMOUNT = 500
const MAX_AMOUNT = 56000
const TEMP_QUOTA = 6000

const formatExpireDate = () => {
  const d = new Date()
  d.setDate(d.getDate() + 1)
  const month = `${d.getMonth() + 1}`.padStart(2, '0')
  const day = `${d.getDate()}`.padStart(2, '0')
  return `${d.getFullYear()}.${month}.${day}`
}

const Skin9: React.FC<Props> = props => {
  const { callBack, type, channelDetail, phoneValue } = props
  const hostNameObj = getHostNameObj()
  const [search] = useSearchParams()

  const [adChannelCode, setAdChannelCode] = useState('')
  const [phone, setPhone] = useState(phoneValue)
  const [code, setCode] = useState('')
  const [showPopup, setShowPopup] = useState(false)
  const [checked, setChecked] = useState(false)
  const [isShake, setIsShake] = useState(false)
  const [amount, setAmount] = useState<string>(parseNum(2000))
  const [currentPeriods, setCurrentPeriods] = useState<number>(24)
  const [monthlyPayment, setMonthlyPayment] = useState('0.00')
  const [timer, setTimer] = useState<ReturnType<typeof setTimeout> | null>()
  const [time, setTime] = useState(0)
  const [expireDate] = useState(formatExpireDate)

  const loginAfterLocation = () => {
    let isHandleCopyFunction = true
    let hasHandleCopyFunction = false
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        position => {
          isHandleCopyFunction = false
          if (hasHandleCopyFunction) {
            return
          }
          getUserLocation(position.coords.latitude, position.coords.longitude)
        },
        () => {
          isHandleCopyFunction = false
          if (hasHandleCopyFunction) {
            return
          }
          getUserLocation(null, null)
        },
      )
      setTimeout(() => {
        if (isHandleCopyFunction) {
          hasHandleCopyFunction = true
          getUserLocation(null, null)
        }
      }, 8000)
    } else {
      getUserLocation(null, null)
    }
  }

  const getUserLocation = async(latitude: any, longitude: any) => {
    const params = latitude ? {
      location: `${latitude},${longitude}`,
      adChannelCode: channelDetail.adChannelCode,
      coordtype: 'wgs84ll',
    } : {
      adChannelCode: channelDetail.adChannelCode,
    }
    const res: any = await activityApi.reverseGeo(params)
    if (res.data.excludeCity && channelDetail.linkType === 2) {
      await activityApi.reportDevice({
        provinceName: res.data.province,
        cityName: res.data.city,
      })
      window.location.href = `/fill-information/success?options=${encodeURIComponent(JSON.stringify({
        isNotFormReq: true,
        isSpecialListCity: true
      }))}`
    } else {
      callBack()
    }
  }

  useEffect(() => {
    const hasToken = Storage.get(TOKEN)
    const channelCode = search.get('adChannelCode')
    if (channelCode) {
      setAdChannelCode(channelCode)
      localStorage.setItem('ad_channel_code', channelCode)
      if (hasToken && channelDetail.location) {
        loginAfterLocation()
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (phoneValue) {
      setPhone(phoneValue)
    }
  }, [phoneValue])

  const getAmountNumber = () => {
    const num = Number(String(amount).replace(/[^\d]/g, ''))
    return Number.isNaN(num) ? 0 : num
  }

  const amountOnChange = (str: string) => {
    const digits = str.replace(/[^\d]/g, '')
    if (digits && digits !== '0') {
      setAmount(digits)
    } else {
      setAmount('')
    }
  }

  const amountOnBlur = () => {
    const num = getAmountNumber()
    if (num > MAX_AMOUNT) {
      setAmount(parseNum(MAX_AMOUNT))
      return Toast.show(`您可借最大金额为${MAX_AMOUNT}元`)
    }
    if (num < MIN_AMOUNT) {
      setAmount(parseNum(MIN_AMOUNT))
      return Toast.show(`最低可借金额为${MIN_AMOUNT}元起`)
    }
    setAmount(parseNum(num))
  }

  const openView = (path: string) => {
    Storage.set(ENTER_AGREEMENT, true)
    window.location.href = `/${path}-agreement?isShowHeader=true`
  }

  const countDownFn = () => {
    setTime(60)
  }

  useEffect(() => {
    if (time > 0) {
      const t = setTimeout(() => {
        setTime(time - 1)
      }, 1000)
      setTimer(t)
    } else {
      timer && clearTimeout(timer)
      setTimer(null)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [time])

  const getCode = async() => {
    if (!phone) {
      return Toast.show('请输入手机号码')
    }
    if (!isPhone(phone)) {
      return Toast.show('手机号码格式有误')
    }
    countDownFn()
    try {
      await activityApi.smsSend({
        mobile: +phone
      })
    } catch (error) {
      timer && clearTimeout(timer)
    }
  }

  const openPopup = () => {
    if (!getAmountNumber()) {
      return Toast.show('请输入借款金额')
    }
    if (!phone) {
      return Toast.show('请输入手机号码')
    }
    if (!isPhone(phone)) {
      return Toast.show('手机号码格式有误')
    }
    if (!checked) {
      setIsShake(true)
      setTimeout(() => {
        setIsShake(false)
      }, 100)
      return Toast.show('请勾选注册及隐私协议')
    }
    if (!time) {
      getCode()
    }
    setShowPopup(true)
  }

  const register = async() => {
    if (!code) {
      return Toast.show('请输入验证码')
    }
    try {
      Toast.show({
        icon: 'loading',
        content: '领取中…',
        duration: 0,
      })
      const queryString = getCachedParamsAsQueryString()
      const loginParams = {
        mobile: phone,
        code,
        adChannelCode,
        abTestType: 5,
        isFormReq: (type === 'getQuota' && adChannelCode !== 'YxNj9v'),
      }
      const res = await activityApi.login(loginParams, queryString)
      Storage.set(TOKEN, res.token)
      clearCachedParams()
      props.onCallBackParams({
        amount: String(getAmountNumber()),
        currentPeriods
      })
      if (channelDetail.location) {
        loginAfterLocation()
      } else {
        callBack()
      }
    } catch (error: any) {
      Toast.clear()
      Toast.show(error.msg)
    }
  }

  useEffect(() => {
    const amountValue = getAmountNumber()
    if (!amountValue) {
      setMonthlyPayment('0.00')
      return
    }
    const result = loanCalculateUtils.calcAverageCapital({
      amount: amountValue,
      term: Number(currentPeriods),
      rate: Number(YEAR_RATE)
    })
    setMonthlyPayment(result.list?.[0]?.monthlyPayment || '0.00')
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPeriods, amount])

  return (
    <div className={styles.registerPage}>
      <div className={styles.loanMoney}>
        <div className={styles.title}>
          借款金额
          <span>(可自定义)</span>
        </div>
        <div className={classNames(styles.moneyInput, isIOS ? styles.ios : styles.android)}>
          <div>
            <span>￥</span>
            <input
              type="tel"
              maxLength={6}
              value={amount}
              onChange={e => amountOnChange(e.target.value)}
              onBlur={amountOnBlur}
              placeholder={`最多可借${MAX_AMOUNT}元`}
            />
          </div>
          <p onClick={() => setAmount(parseNum(MAX_AMOUNT))}>
            <span>全部借出</span>
          </p>
        </div>
        <div className={styles.loanLimit}>
          <ul>
            <li>
              <p>{MAX_AMOUNT}</p>
              <span>总额度(元)</span>
            </li>
            <li>
              <p>0.02%<span>起</span></p>
              <span>日利率</span>
            </li>
            <li>
              <p>15<span>分钟</span></p>
              <span>最快到账时间</span>
            </li>
          </ul>
          <p className={styles.limitTip}>含临时额度{TEMP_QUOTA}元（有效期至{expireDate}）</p>
        </div>
      </div>

      <div className={styles.loanTerm}>
        <ul className={styles.session}>
          <li className={styles.term}>
            <span>借款期限</span>
            <div>
              {
                PERIOD_OPTIONS.map(item => (
                  <p
                    key={item.value}
                    className={classNames(item.value === currentPeriods && styles.active)}
                    onClick={() => setCurrentPeriods(item.value)}
                  >
                    {item.text}
                  </p>
                ))
              }
            </div>
          </li>
          <li>
            <span>还款计划</span>
            <div>
              <p className={styles.desc}>每月应还￥{monthlyPayment}</p>
            </div>
          </li>
          <li>
            <span>支持提现方式</span>
            <div>
              <img src={require('@imgs/register/skin9/icon_wechat.png')} alt="" />
              <span>微信</span>
              <img className={styles.payGap} src={require('@imgs/register/skin9/icon_alipay.png')} alt="" />
              <span>支付宝</span>
              <img className={classNames(styles.payGap, styles.bankIcon)} src={require('@imgs/register/skin9/icon_bank.png')} alt="" />
              <span>储蓄卡</span>
            </div>
          </li>
        </ul>
        <p className={styles.tip}>* 利息测算以年化利率{YEAR_RATE}%为参考，具体额度利率以实际审核为准</p>
        <p className={styles.tip}>* 提前还款免剩余利息</p>
      </div>

      <div className={styles.bottomBody}>
        <div className={styles.phoneBox}>
          <NumberInput
            placeholder="输入手机号领取额度"
            value={phone}
            numberFormat={{
              decimal: false,
              negative: false,
              leadingZero: false,
              maxLength: 11
            }}
            onChange={val => setPhone(val)}
          />
        </div>
        <div className={styles.getCms} onClick={openPopup}>去领取</div>
        <p className={classNames(styles.msg, isShake && styles.animation)}>
          <i className={classNames(styles.checked, checked && styles.active)} onClick={() => setChecked(!checked)}></i>
          我已阅读并同意
          <span onClick={() => openView('register')}>《用户服务协议》</span>
          <span onClick={() => openView('privacy')}>《隐私协议》</span>
        </p>
      </div>

      <div className={styles.zw}></div>

      <div className={styles.bottomMsg}>
        <a href="tel:4006686025">客服电话：4006686025</a>
        <p>本平台为金融信息服务平台</p>
        <p>贷款资金由合作持牌机构提供</p>
        <p>合作机构年化利率为{YEAR_RATE}%-24%</p>
        <p>放款时间、金额及利息以实际审批结果为准</p>
        <p>贷款有风险，借款需谨慎，请合理消费，避免逾期</p>
        <p>平台提醒：官方不会以任何名义向您收取手续费</p>
        <p>一切贷前收取手续费的均有可能是诈骗</p>
        <p>{hostNameObj.filing} | {hostNameObj.companyName}</p>
      </div>

      <div className={classNames(styles.dialogOverlay, showPopup && styles.showPopup)}>
        <div className={styles.dialogMain} onClick={e => e.stopPropagation()}>
          <div className={styles.dialogMainBox}>
            <div className={styles.dialogMainTitle}>
              <h3>请填写验证码</h3>
              <div className={styles.close} onClick={() => setShowPopup(false)}>×</div>
            </div>
            <div className={styles.registerCode}>
              <img src={require('@imgs/register/skin9/icon_safe.png')} alt="" />
              <div className={styles.codeInput}>
                <NumberInput
                  placeholder="请输入验证码"
                  value={code}
                  numberFormat={{
                    decimal: false,
                    negative: false,
                    maxLength: 6
                  }}
                  onChange={val => setCode(val)}
                />
              </div>
              <div className={styles.numberText}>
                {
                  time
                    ? <button type="button" disabled>{time}s</button>
                    : <button type="button" onClick={getCode}>获取验证码</button>
                }
              </div>
            </div>
            <div className={styles.getEnter} onClick={register}>获取额度</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Skin9
